/**
 * Shared layout constants for consistent page widths across the app.
 * 
 * Using max-width with auto margins is preferred over percentage padding because:
 * 1. Maintains readability on very large screens
 * 2. Provides consistent behavior across different screen sizes
 * 3. Follows modern design system best practices
 * 
 * The PAGE_MAX_WIDTH of 1200px with horizontal padding of 1rem (mobile) to 2rem (desktop)
 * creates an effective ~10% margin on 1440px screens and proportionally more on larger screens.
 */

// Maximum content width for main page containers
export const PAGE_MAX_WIDTH = '1200px';

// Horizontal padding values
export const PAGE_PADDING_MOBILE = '1rem';
export const PAGE_PADDING_TABLET = '1.5rem';
export const PAGE_PADDING_DESKTOP = '2rem';

// Breakpoints (matching existing patterns in the codebase)
export const BREAKPOINTS = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1200px',
};

/**
 * CSS mixin for styled-components to apply consistent page container styles.
 * Usage: ${pageContainerStyles}
 */
export const pageContainerStyles = `
  width: 100%;
  max-width: ${PAGE_MAX_WIDTH};
  margin: 0 auto;
  padding-left: ${PAGE_PADDING_MOBILE};
  padding-right: ${PAGE_PADDING_MOBILE};
  box-sizing: border-box;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    padding-left: ${PAGE_PADDING_TABLET};
    padding-right: ${PAGE_PADDING_TABLET};
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    padding-left: ${PAGE_PADDING_DESKTOP};
    padding-right: ${PAGE_PADDING_DESKTOP};
  }
`;

/**
 * CSS mixin for full-height page containers.
 * Usage: ${fullHeightPageStyles}
 */
export const fullHeightPageStyles = `
  ${pageContainerStyles}
  min-height: 100vh;
  min-height: 100dvh;
`;

export default {
  PAGE_MAX_WIDTH,
  PAGE_PADDING_MOBILE,
  PAGE_PADDING_TABLET,
  PAGE_PADDING_DESKTOP,
  BREAKPOINTS,
  pageContainerStyles,
  fullHeightPageStyles,
};
